const { produce } = require("immer");

const init = {
  uid: null,
  name: {
    en: "",
    fr: ""
  },
  key: null,
  appUid: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_serviceForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.app) draft.appUid = action.form.app;
      });

    case "UPDATE_serviceForm":
      return produce(state, draft => {
        Object.assign(draft, action.form, {
          name: Object.assign(draft.name, action.form.name)
        });
      });

    case "RESET_serviceForm":
      return init;

    default:
      return state;
  }
}
